export { default } from "./Can";
